<span
  [style.display]="showInvert ? 'inherit': 'none'"
  style="float: left; position: absolute; left: 2px"
  ><sup>1</sup>/<sub>n</sub></span
><span [ngClass]="{'no-rate-strike': showStrike===true}"
  >&nbsp;&nbsp;&nbsp;{{spotTracking}}&nbsp;&nbsp;&nbsp;</span
>
